import type { FaireProductEntity } from "../../entity_types/product";

export const p_sy7s9rgrdy: FaireProductEntity = {
  token: "p_sy7s9rgrdy",
  type: "product",
  name: "C.C Play Ball Letter Stripe Pattern Trucker Cap",
  brandToken: "b_926lzrw9gt",
  brandName: "Hana",
  imageUrl:
    "https://cdn.faire.com/fastly/efd7e35a1eba32f78efe81d948db61824ac0c399119925ddb7b3c53735c5d4f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03cf533a62a1bc1e38b1c0545c8206955cd75066e2d7bde9030a0e6c8abe0ce5.jpeg",
    "https://cdn.faire.com/fastly/8ec525d2a27fba7dc43c0e5a0f6c5dd99b925e9fff418f6d48eaa1a4ee2fa5fb.jpeg",
  ],
  priceDollars: 8.5,
  description:
    'C.C Play Ball Letter Stripe Pattern Two Tone Trucker Hat Baseball Cap\n100% Cotton\nCircumference 22.5"\nOne Size\nMade in Vietnam',
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:50.513Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
